<template>
    <a
        href="#"
        @click.prevent="setShowAddUserModal(true)"
        class="flex px-4 py-2 items-start gap-2 rounded border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-700 shadow-sm hover:bg-gray-50 dark:hover:bg-slate-600 transition-colors"
        role="button"
        id="hs-wallet-add-user"
    >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="shrink-0">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10 3.33317C8.38917 3.33317 7.08333 4.63901 7.08333 6.24984C7.08333 7.86067 8.38917 9.1665 10 9.1665C11.6108 9.1665 12.9167 7.86067 12.9167 6.24984C12.9167 4.63901 11.6108 3.33317 10 3.33317ZM5.41667 6.24984C5.41667 3.71853 7.46869 1.6665 10 1.6665C12.5313 1.6665 14.5833 3.71853 14.5833 6.24984C14.5833 8.78114 12.5313 10.8332 10 10.8332C7.46869 10.8332 5.41667 8.78114 5.41667 6.24984ZM6.66667 13.3332C5.28595 13.3332 4.16667 14.4525 4.16667 15.8332V16.6665C4.16667 17.1267 3.79357 17.4998 3.33333 17.4998C2.8731 17.4998 2.5 17.1267 2.5 16.6665V15.8332C2.5 13.532 4.36548 11.6665 6.66667 11.6665H10.8333C11.2936 11.6665 11.6667 12.0396 11.6667 12.4998C11.6667 12.9601 11.2936 13.3332 10.8333 13.3332H6.66667Z" fill="#1E293B"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0001 11.6665C15.4603 11.6665 15.8334 12.0396 15.8334 12.4998V14.1665H17.5001C17.9603 14.1665 18.3334 14.5396 18.3334 14.9998C18.3334 15.4601 17.9603 15.8332 17.5001 15.8332H15.8334V17.4998C15.8334 17.9601 15.4603 18.3332 15.0001 18.3332C14.5398 18.3332 14.1667 17.9601 14.1667 17.4998V15.8332H12.5001C12.0398 15.8332 11.6667 15.4601 11.6667 14.9998C11.6667 14.5396 12.0398 14.1665 12.5001 14.1665H14.1667V12.4998C14.1667 12.0396 14.5398 11.6665 15.0001 11.6665Z" fill="#1E293B"/>
        </svg>
        <span class="text-slate-800 dark:text-slate-100 text-sm font-medium leading-5">Add user</span>
    </a>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useWalletStore } from '@/store/wallet';

export default {
    name: 'AddWalletUserBtn',
    props: [],
    components: {},
    directives: {},
    data: () => ({
        errors: [],
    }),
    computed: {
        ...mapState(useWalletStore, ['showAddUserModal']),
    },
    methods: {
        ...mapActions(useWalletStore, ['setShowAddUserModal']),
    },
};
</script>
